import React, { useRef, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import CustomButton from "../../../Components/Common/CustomButton";
import { AiOutlineClose } from "react-icons/ai";
import { updateTenant } from "../../../redux/roles/rolesSlice";
import Loading from "../../../Components/Common/Loading";
import toast from "react-hot-toast";

const EditRoles = ({ show, onClose, role, onSave, setSelectedRole }) => {
  const modalRef = useRef();
  const dispatch = useDispatch();
  const [saving, setSaving] = useState(false);

  const { tenant, loading, error } = useSelector((state) => state.tenant);

  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      onClose();
    }
  };

  useEffect(() => {
    if (show) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [show]);

  function handleRoleedit(e) {
    const { name, value } = e.target;
    setSelectedRole((prev) => ({ ...prev, [name]: value }));
  }

  async function handleSave() {
    setSaving(true);
    const updatedRoles = tenant.roles.map((elm) =>
      elm._id === role._id ? role : elm
    );
    const data = { roles: updatedRoles };

    try {
      await dispatch(updateTenant({ data }));
      onClose();
    } catch (error) {
     
      toast.error("Failed to update role.");
    } finally {
      setSaving(false);
    }
  }

  // async function handleSave() {
  //   const updatedRoles = tenant.roles.map((elm) =>
  //     elm._id === role._id ? role : elm
  //   );

  //   const data = { roles: updatedRoles };
  //   const res = await dispatch(updateTenant({ data }));

  //   onClose();
  // }
  if (!show) return null;

  if (loading || saving) {
    return (
      <div className="absolute inset-0 flex justify-center items-center bg-white bg-opacity-50 z-50">
        <Loading size="12" color="brand-500" />
      </div>
    );
  }

  if (error === "failed") {
    return toast.error(error);
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="absolute inset-0 bg-gray-900/10 backdrop-blur-[1.5px]"></div>
      <div
        ref={modalRef}
        className="bg-white p-6 rounded-md shadow-md w-4/12 max-w-xl relative z-10"
      >
        <h2 className="text-xl mb-4">Edit Role</h2>
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-2xl text-gray-600 font-semibold rounded px-3 py-2"
        >
          <AiOutlineClose />
        </button>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">
            Name*
          </label>
          <input
            type="text"
            name="role"
            value={role.role}
            onChange={handleRoleedit}
            placeholder="Name"
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm"
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">
            Description*
          </label>
          <input
            type="text"
            name="description"
            value={role.description}
            onChange={handleRoleedit}
            placeholder="Description"
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm"
          />
        </div>
        <div className="flex justify-end space-x-4">
          <button
            onClick={handleSave}
            className="px-4 pb-1 pt-[2px] text-[16px] bg-brand-500 text-white hover:bg-brand-600 transition duration-300 ease-in-out rounded"
            disabled={saving}
          >
            {saving ? <Loading size="16" color="brand-500" /> : "Save"}
          </button>
          <CustomButton onClick={onClose} text={"Cancel"} />
        </div>
      </div>
    </div>
  );
};

export default EditRoles;
